<form action="" [formGroup]="searchForm">
  <div class="border rounded-pill p-1 defaultWidth d-flex">
    <div class="input-group-prepend border-0">
      <button id="button-addon4" type="button" class="btn btn-link text-info">
        <i class="fa fa-search"></i>
      </button>
    </div>
    <!-- form-control formControlName="searchText" (keyup)="onKeyUp($event.target.value)" [(ngModel)]="searchSubject" (ngModelChange)='changed($event)' -->
    <div class="d-flex w-100 search-box">
      <input type="search" [placeholder]="'page.search' | translate" formControlName="searchText"
        aria-describedby="button-addon4" class="bg-none border-0 w-100" (keypress)="omit_number($event)" />
    </div>
  </div>
</form>